(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fudge-WbOw4-product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						// Filter out redundant bulk-pack products when current product has matching MOQ
						var moq = this.getAttribute('data-product-moq');
						if (moq && moq !== '1' && moq !== '0' && moq !== '') {
							var moqStuks = moq + ' stuks';
							var items = this.querySelectorAll('.grid-item');
							items.forEach(function(item) {
								var titleEl = item.querySelector('.card-heading');
								if (titleEl && titleEl.textContent.indexOf(moqStuks) > -1) {
									item.remove();
								}
							});
						}
					}

					if (html.querySelector('.grid-item')) {
						this.classList.add('product-recommendations--loaded');
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fudge-yULw9-cross-sell"] && !Shopify.designMode) return;
  try {
    
class FudgeCrossSell extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('fudge-cross-sell');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						// Filter out redundant bulk-pack products when current product has matching MOQ
						var moq = this.getAttribute('data-product-moq');
						if (moq && moq !== '1' && moq !== '0' && moq !== '') {
							var moqStuks = moq + ' stuks';
							var items = this.querySelectorAll('.grid-item');
							items.forEach(function(item) {
								var titleEl = item.querySelector('.card-heading');
								if (titleEl && titleEl.textContent.indexOf(moqStuks) > -1) {
									item.remove();
								}
							});
						}
					}

						if (this.querySelector('.grid-item')) {
							this.classList.add('product-recommendations--loaded');
							var sec = this.closest('.shopify-section');
							if (sec) sec.style.display = 'block';
						} else {
							var sec = this.closest('.shopify-section');
							if (sec) sec.style.display = 'none';
						}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('fudge-cross-sell', FudgeCrossSell);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).catch(function(e) { console.error('Cart note update failed:', e); });
			}, 300))
	}
}

customElements.define('cart-note', CartNote);

class CartReference extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ attributes: { referentie: event.target.value } });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).catch(function(e) { console.error('Cart reference update failed:', e); });
    }, 300));
  }
}
customElements.define('cart-reference', CartReference);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (html.querySelector('.grid-item')) {
						this.classList.add('product-recommendations--loaded');
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
